const accessRoute = {
  USER_MANAGEMENT: {
    path: "/admin/user-management",
  },
};
export default accessRoute;
